/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Localized from '../../../../../../shared/components/Localized';
import Button from '../../../../../components/Button';

const ModelHeader = styled.div`
display: flex;
flex-direction: column;
height: 4.75rem;
border-radius: 0.25rem;
box-shadow: 0 0.125rem 0 0 #f0f2f7;
background-color: #ffffff;
justify-content: center;
align-items: center;
@media (min-width: 20rem) and (max-width: 30rem) {
  height: 4.125rem;
}
`;
const ModelHeading = styled.p`
margin-top: 1rem;
font-family: 'Salesforce Sans';
font-size: 1.25rem;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: normal;
letter-spacing: normal;
text-align: center;
color: #2b2826;
@media (min-width: 20rem) and (max-width: 30rem) {
  height: 4.125rem;
  font-size: 1.125rem;
  text-align: center;
}
`;
const ModelSubHeader = styled.p`
  font-family: "Salesforce Sans";
  font-size: 12px;
  padding-bottom: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  margin-top: 8px;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #706e6b;
`;
const ModelIntro = styled.p`
  margin-top: 36px;
  margin-left: 96px;
  font-family: "Salesforce Sans";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #706e6b;
  @media (min-width: 320px) and (max-width: 480px) {

    color: #706e6b;
    margin-top: 18px;
    margin-left: 0;
    margin-right: 8.125rem;
  }
`;
const ErrorMessage = styled.p`
  font-family: Salesforce Sans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #c23934;
  margin-left: 96px;
  margin-top: 4px;
`;

const InputLabel = styled.p`
  margin-top: 8px;
  margin-left: 96px;

  font-family: "Salesforce Sans";
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.17;
  letter-spacing: 0.5px;
  color: rgb(43, 40, 38);;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-left: 0;
    margin-right: 8.125rem;
  }
`;

const SignupButton = styled(Button)`
  margin: 18px 8px 0px 14px;
  font-family: "Salesforce Sans";
  font-size: 12px;
  letter-spacing: normal;
  text-align: center;
  height: 36px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 18px 8px 0px 14px;
  }
`;

const BlueInputSection = styled.div`
  background: rgb(244, 246, 249);
  border-radius: 4px;
  height: 136px;
  width: 437px;
  margin-top: 18px;
  margin-left: 96px;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 90%;
    margin-left: 0;
    margin: 0 auto;
    max-width: 320px;
  }
`;

const InputComponent = styled.input`
  background: rgb(255, 255, 255);
  border-radius: 4px;
  border: 1px solid rgb(221, 219, 218);
  height:32px;
  width: 207px;
  margin-left: 8px;
  margin-top: 16px;

`;

const InputSection = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 90%;
    margin: 0 auto;
  }
`;

const SelectDiv = styled.div.attrs({
  className: 'slds-select_container'
})`
  margin-top: 16px;
  height: 32px;
  width: 180px;
`;
const ModelContent = styled.div`
@media (min-width: 320px) and (max-width: 480px) {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: 100%;
}
`;
const RegistrationInfo = styled.p`
  color: rgb(112, 110, 107);
  font-family: Salesforce Sans
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 18px;
  margin: 16px 0px 18px 12px;
  max-height: 100%;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 16px 0px 18px 12px;
  }
`;

const AddBlock = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 8px;
`;
class AddPhoneNumber extends React.Component {
  static propTypes = {
    requests: PropTypes.object,
    onClose: PropTypes.func,
    phoneNumber: PropTypes.string,
    onKeyPress: PropTypes.func,
    onChange: PropTypes.func,
    setModal: PropTypes.func,
    countryCode: PropTypes.string,
    onCountryCodeChange: PropTypes.func,
    onPhoneNumberChange: PropTypes.func,
    submit: PropTypes.func,
  };

  render() {
    const {
      phoneNumber, onPhoneNumberChange, onKeyPress, submit, countryCode, onCountryCodeChange
    } = this.props;
    const allowAdd = (/^\d+$/).test(phoneNumber);
    function placeHolderText() {
      return 'Add phone number';
    }

    return (
      <div>
        <ModelHeader>
          <ModelHeading>
            <Localized modelName={'addPhoneNumber'} modelKey={'addLabel'} modelAttribute={'label'} />
          </ModelHeading>
        </ModelHeader>
        <ModelContent>
          <ModelIntro>
            <Localized modelName={'addPhoneNumber'} modelKey={'phoneNumberLabel'} modelAttribute={'label'} />
          </ModelIntro>
          <InputLabel>
            {this.props.requests.subscriber.value.phoneNumber || <Localized modelName={'addPhoneNumber'} modelKey={'noNumber'} modelAttribute={'label'} />}
          </InputLabel>
          <BlueInputSection>
            <InputSection>
              <SelectDiv>
                <select onChange={onCountryCodeChange} className="slds-select">
                {this.props.requests.countryCodes.value?.map((c) => (
                  <option key={c.name}  c-key={c.name} value={c.code}>{`${c.name} (+${c.code})`}</option>
                ))}
                </select>
              </SelectDiv>
              <InputComponent
                className="slds-input"
                placeholder={placeHolderText()}
                value={phoneNumber}
                size={10}
                maxLength={20}
                minLength={10}
                onChange={onPhoneNumberChange}
                onKeyPress={onKeyPress}
              />
            </InputSection>
            <AddBlock>
              <SignupButton disabled={!allowAdd} onClick={submit} theme="neutral">
                <Localized modelName={"addPhoneNumber"} modelKey={'addButton'} modelAttribute={"label"} />
              </SignupButton>
              <RegistrationInfo>
                <Localized modelName={"addPhoneNumber"} modelKey={'registrationInfo'} modelAttribute={"label"} hasLinks={true}/>
              </RegistrationInfo>
            </AddBlock>
          </BlueInputSection>
        </ModelContent>
      </div>
    );
  }
}

export default AddPhoneNumber;
